import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import { theme } from "@theme";
import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

const AndroidDismissButton = ({ onPress }: { onPress: () => void }) => {
  const insets = useSafeAreaInsets();

  if (Platform.OS !== "android") {
    return null;
  }

  return (
    <LBox
      position="absolute"
      top={insets.top + theme.spacing.s2}
      right={theme.spacing.s4 + theme.spacing.s2}
      style={{ zIndex: 10, elevation: 10 }}
    >
      <LPressable
        accessibilityLabel="Close access details"
        accessibilityRole="button"
        hitSlop={8}
        onPress={onPress}
        sentryEventName="AccessDetail.AndroidDismiss"
      >
        <LBox
          width={44}
          height={44}
          borderRadius="max"
          alignItems="center"
          justifyContent="center"
          backgroundColor="blackTranslucent50"
          borderWidth={1}
          borderColor="whiteTranslucent20"
        >
          <LIcon name="chevron" size={22} stroke="white" />
        </LBox>
      </LPressable>
    </LBox>
  );
};

export default AndroidDismissButton;
